module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"meta":{"title":"Tasty Discounts, Deals & Offers | Just Eat"}},"en-AU":{"meta":{"title":"Tasty Discounts, Deals & Offers | Menulog"}},"en-NZ":{"meta":{"title":"Tasty Discounts, Deals & Offers | Menulog"}}}')
  delete Component.options._Ctor
}
